import { DEFAULT_BILLING_DETAILS } from '~/constants/checkout';

export const CART_ITEMS_URL = '/api/v2/cart/items/';

export const INITIAL_CONTEXT = {
  cart: undefined,
  user: undefined,
  savedItems: undefined,
  billingDetails: DEFAULT_BILLING_DETAILS,
  plusUpsellVariant: '',
};
export const SUBSCRIPTIONS_HEADER_TITLE_LIST = ['Product', 'Price'];
export const DEALS_HEADER_TITLE_LIST = [
  'Product',
  'Plan type',
  'Quantity',
  'Price',
];

export enum CouponType {
  FIXED = 0,
  PERCENTAGE_OFF = 1,
}
